import { logger } from '@/modules/common/logging/logger';
import { LassieMini, Lassie, ShuttleRack, Design, HikStorage } from '@thive/fddm-types';
import { Vector2 } from 'three';

import { ITpsService } from './ITpsService';

export class TpsServiceLogDecorator implements ITpsService {
  private decoree: ITpsService;

  constructor(decoree: ITpsService) {
    this.decoree = decoree;
  }

  async generateLassieTemplate(center: Vector2): Promise<void> {
    const start = this.logStart('generateLassieTemplate');
    await this.decoree.generateLassieTemplate(center);
    this.logEnd('generateLassieTemplate', start);
  }

  async generateLassieMiniTemplate(center: Vector2): Promise<void> {
    const start = this.logStart('generateLassieMiniTemplate');
    await this.decoree.generateLassieMiniTemplate(center);
    this.logEnd('generateLassieMiniTemplate', start);
  }

  async generateShuttleTemplate(center: Vector2): Promise<void> {
    const start = this.logStart('generateShuttleTemplate');
    await this.decoree.generateShuttleTemplate(center);
    this.logEnd('generateShuttleTemplate', start);
  }

  async generateHikTemplate(center: Vector2): Promise<void> {
    const start = this.logStart('generateHikTemplate');
    await this.decoree.generateHikTemplate(center);
    this.logEnd('generateHikTemplate', start);
  }

  async regenerateLassieTemplate(
    lassieGroup: Lassie,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    const start = this.logStart('regenerateLassieTemplate');
    const result = await this.decoree.regenerateLassieTemplate(lassieGroup);
    this.logEnd('regenerateLassieTemplate', start);
    return result;
  }

  async regenerateLassieMiniTemplate(
    lassieMiniGroup: LassieMini,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    const start = this.logStart('regenerateLassieMiniTemplate');
    const result = await this.decoree.regenerateLassieMiniTemplate(lassieMiniGroup);
    this.logEnd('regenerateLassieMiniTemplate', start);
    return result;
  }

  async regenerateShuttleTemplate(
    shuttleGroup: ShuttleRack,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    const start = this.logStart('regenerateShuttleTemplate');
    const result = await this.decoree.regenerateShuttleTemplate(shuttleGroup);
    this.logEnd('regenerateShuttleTemplate', start);
    return result;
  }

  async regenerateHikTemplate(
    hikGroup: HikStorage,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    const start = this.logStart('regenerateHikTemplate');
    const result = await this.decoree.regenerateHikTemplate(hikGroup);
    this.logEnd('regenerateHikTemplate', start);
    return result;
  }

  // private utility methods

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
